import { Check, Close, ScheduleOutlined } from '@mui/icons-material';
import type { SvgIcon } from '@mui/material';
import { DICOMApprovalStatus } from '~/domain/dicom/dicomConstants';

export interface ApprovalStatusMark {
    readonly Icon: typeof SvgIcon;
    /** Message id of the word that names the status. */
    readonly labelId: 'approved' | 'rejected' | 'unapproved';
}

/**
 * The glyph and the word of an approval status. It carries no colour.
 * Anything not approved or rejected reads as unapproved.
 */
export function approvalStatusMark(
    status: DICOMApprovalStatus
): ApprovalStatusMark {
    switch (status) {
        case DICOMApprovalStatus.APPROVED:
            return { Icon: Check, labelId: 'approved' };
        case DICOMApprovalStatus.REJECTED:
            return { Icon: Close, labelId: 'rejected' };
        default:
            return { Icon: ScheduleOutlined, labelId: 'unapproved' };
    }
}
